import React, { ReactElement } from "react";
import CorporateEmployeeGroupList from "../../components/Corporate/EmployeeGroup";
import Layout from "../../components/layout";

const CorporateEmployeeGroupPage = (): ReactElement => {
  return (
    <Layout>
      <CorporateEmployeeGroupList />
    </Layout>
  );
};

export default CorporateEmployeeGroupPage;
